var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import mtzService from "@/core/services/mtzService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { AreaActions } from "@/store/enums/mtzEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let AreaModule = class AreaModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = AreaActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            mtzService.getFile("Area/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Area.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    // Método para upload da planilha (usando FormData)
    [_b = AreaActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            mtzService.postFile("Area/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = AreaActions.POST_AREA](data) {
        return new Promise(resolve => {
            mtzService.post("Area/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = AreaActions.PUT_AREA](data) {
        return new Promise(resolve => {
            mtzService.put("Area/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = AreaActions.DELETE_AREA](data) {
        return new Promise(resolve => {
            mtzService.delete("Area/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = AreaActions.DELETE_RANGE_AREA](data) {
        return new Promise(resolve => {
            mtzService.delete("Area/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = AreaActions.FILTER_AREA](data) {
        return new Promise(resolve => {
            mtzService.post("Area/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = AreaActions.GET_AREA]() {
        return new Promise(resolve => {
            mtzService.get("Area/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = AreaActions.GETWITHDISABLED_AREA]() {
        return new Promise(resolve => {
            mtzService.get("Area/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = AreaActions.GET_BY_ID_AREA](data) {
        return new Promise(resolve => {
            mtzService.get("Area/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AreaModule.prototype, _k, null);
AreaModule = __decorate([
    Module
], AreaModule);
export default AreaModule;
//# sourceMappingURL=AreaModule.js.map